import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getFixedItemAvailableColumns } from './api';

export const path = '/calculator-tariff/fixed-item/list';

const PageFixedItems: React.FC = (props) => {
  const FixedItems = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getFixedItemAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <FixedItems {...props} />;
};

export default PageFixedItems;
